import { MdPublish, MdReorder } from 'react-icons/md';
import { TabLayoutDataItem } from '../../../../constants';
import { TransportationFee } from './TransportationFee';
import { TabModel } from '../../../../models';
import { LastMonthTemplate } from './tabs/LastMonth.template';
import { RecentTemplate } from './tabs/Recent.template';

/**
 * 화면 > 탭
 * @window w_tb_ca640_pa105_01w
 * @category 월유류비내역
 */
export const TransportationFeeTab: Array<TabLayoutDataItem<TransportationFee>> = [
  {
    tab: new TabModel('RE', MdReorder, '최근6개월교통비/통행료현황'),
    template: (scope) => <RecentTemplate scope={scope} />,
  },
  {
    tab: new TabModel('LA', MdPublish, '전월대비교통비/통행료현황'),
    template: (scope) => <LastMonthTemplate scope={scope} />,
  },
];
